'use client'

import { useContext, useEffect, useMemo, useState } from "react"
import { LiveStreamContext, shareInfoTypes } from "../_config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { usePathname } from "next/navigation";
import PageBanner from "@/components_mobile/banner/page_banner";
import { BannerContext } from "@/context/bannerContext";
import { DeviceContext } from "@/context/deviceContext";
import { SportsLiveListType } from "@/type/list";
import loadingJson from "@/public/media/load_data.json"
import Lottie from "react-lottie-player"
import customAlert from "@/util/customAlert";
import Head from "next/head"
import CopyButton from "./button_copy";
import ShareButton from "./button_share";


export default function LiveStreamView() {
    const { page_top_banner } = useContext(BannerContext)
    const { mobileMode } = useContext(DeviceContext)
    const { stream_1, stream_2, stream_3, stream_4, streamLen } = useContext(LiveStreamContext)

    // useEffect(()=> {console.log(stream_1, stream_2, stream_3, stream_4, streamLen)}, [stream_1, stream_2, stream_3, stream_4, streamLen])
    return (
        <>
            {
                streamLen == 1 && stream_1
                    ? <Head>
                        <title>{`${stream_1.home_name} vs ${stream_1.away_name} - SPON.TV`}</title>
                        <meta property="og:title" content={`${stream_1.home_name} vs ${stream_1.away_name}`} />
                        <meta property="og:description" content={`${stream_1.leagueName} ${stream_1.home_name} vs ${stream_1.away_name}`} />
                        <meta property="og:image" content={stream_1.thumbnail} />
                        <meta property="og:url" content={`https://spontv.com/livebroadcast/?view_code=${stream_1.code}`} />
                    </Head>
                    : <></>
            }
            <div className={`live-sports-stream-view ${streamLen == 1 && !stream_1 ? "" : "pip-mode"}`}>
                {
                    <div className={`banner  ${streamLen > 1 ? 'col-2' : "single-stream"}`} >
                        {
                            streamLen == 1 && !stream_1
                                ? <PageBanner bannerMap={mobileMode ? page_top_banner.get(70) : page_top_banner.get(30)} />
                                : <>
                                    {stream_1 && <StreamComp index={1} streamData={stream_1} key={stream_1.code || Math.random()} /> || <div></div>}
                                    {
                                        streamLen >= 2
                                            ? stream_2 && <StreamComp index={2} streamData={stream_2} key={stream_2.code || Math.random()} /> || <div></div>
                                            : <></>
                                    }
                                    {
                                        streamLen > 2
                                        && <>
                                            {stream_3 && <StreamComp index={3} streamData={stream_3} key={stream_3.code || Math.random()} /> || <div></div>}
                                            {stream_4 && <StreamComp index={4} streamData={stream_4} key={stream_4.code || Math.random()} /> || <div></div>}
                                        </>
                                    }
                                </>
                        }
                    </div>
                }
            </div>
        </>
    )
}

function StreamComp({ index, streamData, key }:
    { index: number, streamData: SportsLiveListType, key: any }) {
    const { DelViewUrl, setOpenWebShare, setShareInfo, streamLen } = useContext(LiveStreamContext)
    const { mobileMode } = useContext(DeviceContext)
    const [mount, setMount] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const pathName = usePathname()


    const [isVisible, setIsVisible] = useState(false);
    // iOS Safari 감지
    const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    };
    const isInStandaloneMode = () => {
        return (
            // 아이폰
            ('standalone' in window.navigator && (window.navigator as any).standalone) ||
            // 이ㅏㄴ드로읻,
            window.matchMedia('(display-mode: standalone)').matches
        );
    };
    useEffect(() => {
        if (isInStandaloneMode() && isIos()) {
            if (mobileMode) {
                setIsVisible(true)
            }
        }
    }, []);

    const videoSrc: string = useMemo(() => {
        const playerIdx = index - 1
        let playerPathQuery = "";

        // if (streamData.video_src.indexOf("liventv.com/") > -1) {
        //     // 기존꺼
        //     playerPathQuery = streamData.video_src.split("liventv.com/")[1]

        //     if(playerIdx){
        //         // 0번 이상이면 번호 붙여서 다른 도메인으로
        //         return `https://player${playerIdx}.liventv.com/` + playerPathQuery
        //     }
        // } 
        return streamData.video_src;

        // console.log(index, playerPathQuery)

    }, [index, streamData])


    const closeHtml = (
        <span className="close-view" onClick={e => DelViewUrl(index)}>
            <FontAwesomeIcon icon={faXmark} />
        </span>
    );

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1200)
    }, [streamData])

    return (
        <div data-index={index} key={streamData.code}>
            {
                loading
                    ? <div className="loading-cover">
                        <Lottie loop animationData={loadingJson} play style={{ aspectRatio: "16 / 9", margin: "0 auto" }} />
                    </div>
                    : <div className="stream-float">
                        {streamData.video && closeHtml}
                        <iframe key={streamData.code} src={videoSrc} frameBorder={0}
                            allowFullScreen={false} scrolling="no" allow="autoplay; fullscreen; picture-in-picture"
                            referrerPolicy="unsafe-url"></iframe>
                    </div>
            }


            {
                streamData.leagueName != 'HD' &&
                <div className="share-button" >

                    {isVisible && <CopyButton pathName={pathName} streamDataCode={streamData.code} />}
                    {streamLen == 1 && <ShareButton pathName={pathName} streamData={streamData} />}



                </div>
            }

        </div>
    )
}